import React from "react"
import Lottie from "@shared/uiNew/LazyLottie"

import ProcessStepsSection from "@shared/uiNew/ProcessStepsSection"

import markerAnimationHero from "@shared/animations/animation_6.json"
import stepImage1 from "../assets/support_1.webp"
import stepImage2 from "../assets/support_2.webp"
import stepImage3 from "../assets/support_3.png"
import stepImage4 from "../assets/support_4.png"

import * as styles from "../styles.module.scss"

const Support = (props) => (
  <ProcessStepsSection
    title={titleSupport}
    description={supportDesc}
    steps={supportArray}
    bubble={supportBubble}
    buttonProps={{
      text: "Оставить заявку на демо",
      icon: "arrow",
      style: styles.buttonSupport,
    }}
  />
)

export default Support

const titleSupport = (
  <h2 className={`${styles.supportTitle} h1`}>
    Чат, который помогает
    <br />
    <span className={styles.supportHighlight}>
      отвечать быстрее
      <Lottie className={styles.supportHighlightMarker} animationData={markerAnimationHero} loop={false} autoplay />
    </span>
  </h2>
)

const supportBubble = (
  <h4 className={styles.bubble}>
    <svg width="15" height="19" viewBox="0 0 15 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.1834 4.73815C12.1834 7.35496 10.064 9.47631 7.44968 9.47631C4.83532 9.47631 2.71595 7.35496 2.71595 4.73815C2.71595 2.12134 4.83532 0 7.44968 0C10.064 0 12.1834 2.12134 12.1834 4.73815Z"
        fill="#A7A7FF"
      />
      <path
        d="M7.40234 10.9925C4.27738 10.9925 1.5709 12.7859 0.254182 15.4006C-0.672916 17.2416 1.07331 19 3.13454 19H11.6701C13.7314 19 15.4776 17.2416 14.5505 15.4006C13.2338 12.7859 10.5273 10.9925 7.40234 10.9925Z"
        fill="#A7A7FF"
      />
    </svg>
    Для поддержки
  </h4>
)

const supportDesc = (
  <p className={styles.supportSubtitle}>
    40% посетителей могут уйти к конкурентам, если не получат ответ в течение первой минуты. Вот что помогает вашей команде отвечать быстрее и точнее
  </p>
)

const supportArray = [
  {
    id: 1,
    title: "Шаблоны ответов",
    text: "Сохраняйте лучшие скрипты и отвечайте на частые вопросы в один клик. Скорость растет, а качество сервиса остается стабильно высоким.",
    image: stepImage1,
    imageAlt: "Шаблоны ответов",
  },
  {
    id: 2,
    title: "Совместная работа",
    text: "Нужно подключить технического специалиста? Передайте диалог коллеге или пригласите его в чат — клиенту не придется повторять проблему дважды.",
    image: stepImage2,
    imageAlt: "Совместная работа",
  },
  {
    id: 3,
    title: "AI-бот на первой линии",
    text: "Бот берет на себя рутину, позволяя операторам сосредоточиться на сложных запросах без расширения штата.",
    image: stepImage3,
    imageAlt: "AI-бот на первой линии",
  },
  {
    id: 4,
    title: "Умная маршрутизация обращений",
    text: 'Автоматически направляйте диалоги нужным специалистам в зависимости от тематики, VIP-статуса клиента или языка обращения. Клиент сразу попадает к компетентному сотруднику, минуя лишние переключения".',
    image: stepImage4,
    imageAlt: "Умная маршрутизация обращений",
  },
]
